/* tslint:disable */
/* eslint-disable */
/**
 * REGUZA
 * Aspe licensing management tool
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApproveOfferRequest,
  ApproveOfferResponse,
  GroupedAcquisition,
  Offer,
  OfferProductApi,
  TerminateOfferRequest,
  UpdateOfferProductsRequest,
} from '../models/index';
import {
    ApproveOfferRequestFromJSON,
    ApproveOfferRequestToJSON,
    ApproveOfferResponseFromJSON,
    ApproveOfferResponseToJSON,
    GroupedAcquisitionFromJSON,
    GroupedAcquisitionToJSON,
    OfferFromJSON,
    OfferToJSON,
    OfferProductApiFromJSON,
    OfferProductApiToJSON,
    TerminateOfferRequestFromJSON,
    TerminateOfferRequestToJSON,
    UpdateOfferProductsRequestFromJSON,
    UpdateOfferProductsRequestToJSON,
} from '../models/index';

export interface ApproveOfferOperationRequest {
    customerId: number;
    offerId: number;
    approveOfferRequest: ApproveOfferRequest;
}

export interface CreateOfferRequest {
    customerId: number;
}

export interface DeleteOfferRequest {
    customerId: number;
    offerId: number;
}

export interface GetOfferRequest {
    customerId: number;
    offerId: number;
}

export interface GetOfferProductsRequest {
    customerId: number;
    offerId: number;
}

export interface GetOffersRequest {
    customerId: number;
}

export interface TerminateOfferOperationRequest {
    customerId: number;
    offerId: number;
    terminateOfferRequest: TerminateOfferRequest;
}

export interface UpdateOfferProductsOperationRequest {
    customerId: number;
    offerId: number;
    updateOfferProductsRequest: UpdateOfferProductsRequest;
}

/**
 * 
 */
export class OffersApi extends runtime.BaseAPI {

    /**
     */
    async approveOfferRaw(requestParameters: ApproveOfferOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApproveOfferResponse>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling approveOffer().'
            );
        }

        if (requestParameters['offerId'] == null) {
            throw new runtime.RequiredError(
                'offerId',
                'Required parameter "offerId" was null or undefined when calling approveOffer().'
            );
        }

        if (requestParameters['approveOfferRequest'] == null) {
            throw new runtime.RequiredError(
                'approveOfferRequest',
                'Required parameter "approveOfferRequest" was null or undefined when calling approveOffer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/customers/{customerId}/offers/{offerId}/approve`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));
        urlPath = urlPath.replace(`{${"offerId"}}`, encodeURIComponent(String(requestParameters['offerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ApproveOfferRequestToJSON(requestParameters['approveOfferRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApproveOfferResponseFromJSON(jsonValue));
    }

    /**
     */
    async approveOffer(requestParameters: ApproveOfferOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApproveOfferResponse> {
        const response = await this.approveOfferRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createOfferRaw(requestParameters: CreateOfferRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Offer>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling createOffer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/customers/{customerId}/offers`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OfferFromJSON(jsonValue));
    }

    /**
     */
    async createOffer(requestParameters: CreateOfferRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Offer> {
        const response = await this.createOfferRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async deleteOfferRaw(requestParameters: DeleteOfferRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling deleteOffer().'
            );
        }

        if (requestParameters['offerId'] == null) {
            throw new runtime.RequiredError(
                'offerId',
                'Required parameter "offerId" was null or undefined when calling deleteOffer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/customers/{customerId}/offers/{offerId}`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));
        urlPath = urlPath.replace(`{${"offerId"}}`, encodeURIComponent(String(requestParameters['offerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteOffer(requestParameters: DeleteOfferRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteOfferRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getAllOffersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Offer>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/offers`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OfferFromJSON));
    }

    /**
     */
    async getAllOffers(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Offer>> {
        const response = await this.getAllOffersRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getNewAcquisitionRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GroupedAcquisition>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/new/acquisition`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GroupedAcquisitionFromJSON));
    }

    /**
     */
    async getNewAcquisition(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GroupedAcquisition>> {
        const response = await this.getNewAcquisitionRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getNewAmendmentsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GroupedAcquisition>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/new/amendments`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GroupedAcquisitionFromJSON));
    }

    /**
     */
    async getNewAmendments(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GroupedAcquisition>> {
        const response = await this.getNewAmendmentsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getOfferRaw(requestParameters: GetOfferRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Offer>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling getOffer().'
            );
        }

        if (requestParameters['offerId'] == null) {
            throw new runtime.RequiredError(
                'offerId',
                'Required parameter "offerId" was null or undefined when calling getOffer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/customers/{customerId}/offers/{offerId}`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));
        urlPath = urlPath.replace(`{${"offerId"}}`, encodeURIComponent(String(requestParameters['offerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OfferFromJSON(jsonValue));
    }

    /**
     */
    async getOffer(requestParameters: GetOfferRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Offer> {
        const response = await this.getOfferRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getOfferProductsRaw(requestParameters: GetOfferProductsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OfferProductApi>>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling getOfferProducts().'
            );
        }

        if (requestParameters['offerId'] == null) {
            throw new runtime.RequiredError(
                'offerId',
                'Required parameter "offerId" was null or undefined when calling getOfferProducts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/customers/{customerId}/offers/{offerId}/products`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));
        urlPath = urlPath.replace(`{${"offerId"}}`, encodeURIComponent(String(requestParameters['offerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OfferProductApiFromJSON));
    }

    /**
     */
    async getOfferProducts(requestParameters: GetOfferProductsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OfferProductApi>> {
        const response = await this.getOfferProductsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getOffersRaw(requestParameters: GetOffersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Offer>>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling getOffers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/customers/{customerId}/offers`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OfferFromJSON));
    }

    /**
     */
    async getOffers(requestParameters: GetOffersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Offer>> {
        const response = await this.getOffersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async terminateOfferRaw(requestParameters: TerminateOfferOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling terminateOffer().'
            );
        }

        if (requestParameters['offerId'] == null) {
            throw new runtime.RequiredError(
                'offerId',
                'Required parameter "offerId" was null or undefined when calling terminateOffer().'
            );
        }

        if (requestParameters['terminateOfferRequest'] == null) {
            throw new runtime.RequiredError(
                'terminateOfferRequest',
                'Required parameter "terminateOfferRequest" was null or undefined when calling terminateOffer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/customers/{customerId}/offers/{offerId}/terminate`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));
        urlPath = urlPath.replace(`{${"offerId"}}`, encodeURIComponent(String(requestParameters['offerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: TerminateOfferRequestToJSON(requestParameters['terminateOfferRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async terminateOffer(requestParameters: TerminateOfferOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.terminateOfferRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateOfferProductsRaw(requestParameters: UpdateOfferProductsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling updateOfferProducts().'
            );
        }

        if (requestParameters['offerId'] == null) {
            throw new runtime.RequiredError(
                'offerId',
                'Required parameter "offerId" was null or undefined when calling updateOfferProducts().'
            );
        }

        if (requestParameters['updateOfferProductsRequest'] == null) {
            throw new runtime.RequiredError(
                'updateOfferProductsRequest',
                'Required parameter "updateOfferProductsRequest" was null or undefined when calling updateOfferProducts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/customers/{customerId}/offers/{offerId}/products`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));
        urlPath = urlPath.replace(`{${"offerId"}}`, encodeURIComponent(String(requestParameters['offerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateOfferProductsRequestToJSON(requestParameters['updateOfferProductsRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateOfferProducts(requestParameters: UpdateOfferProductsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateOfferProductsRaw(requestParameters, initOverrides);
    }

}
